var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardSavedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 39,
    viewBox: "0 0 52 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0833 0H11.9167C8.75723 0.00344103 5.72817 1.26005 3.49411 3.49411C1.26005 5.72817 0.00344103 8.75723 0 11.9167L0 27.0833C0.00344103 30.2428 1.26005 33.2718 3.49411 35.5059C5.72817 37.74 8.75723 38.9966 11.9167 39H40.0833C43.2428 38.9966 46.2718 37.74 48.5059 35.5059C50.74 33.2718 51.9966 30.2428 52 27.0833V11.9167C51.9966 8.75723 50.74 5.72817 48.5059 3.49411C46.2718 1.26005 43.2428 0.00344103 40.0833 0ZM11.9167 6.5H40.0833C41.3317 6.50024 42.5416 6.93166 43.5085 7.72127C44.4754 8.51088 45.1398 9.61022 45.3895 10.8333H6.6105C6.86017 9.61022 7.52464 8.51088 8.49152 7.72127C9.4584 6.93166 10.6683 6.50024 11.9167 6.5ZM40.0833 32.5H11.9167C10.4801 32.5 9.10233 31.9293 8.0865 30.9135C7.07068 29.8977 6.5 28.5199 6.5 27.0833V17.3333H45.5V27.0833C45.5 28.5199 44.9293 29.8977 43.9135 30.9135C42.8977 31.9293 41.5199 32.5 40.0833 32.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSavedIcon);
export default __webpack_public_path__ + "static/media/cardSavedIcon.db4026b247652daa7f89622d89fdd207.svg";
export { ForwardRef as ReactComponent };